import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import SectionCarousel from '../Components/SectionCarousel';
import SectionContact from '../Components/SectionContact';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import SectionService from '../Components/SectionService';
import SectionHomeService from '../Components/SectionHomeService';

const Service = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Services' detail='We offer a full range of legal services to support individuals, businesses, and organizations with clarity and confidence.' bg={Bg} />
      <section className='pt-5 pb-5 mt-5 mb-5'>
        <Container>
          <Row>
            <Col>
              <SectionHomeService hideHeader={true} />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

Service.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default Service